import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInAdmin } from '../firebase/config';
import './AdminLogin.css';

const AdminLogin = () => {
    const [credentials, setCredentials] = useState({
        email: '',
        password: ''
    });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setCredentials(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            // Authenticate with Firebase using email and password
            const result = await signInAdmin(credentials.email, credentials.password);

            if (result.success) {
                // Store authentication state
                localStorage.setItem('adminAuth', 'true');
                localStorage.setItem('adminUser', credentials.email);
                navigate('/admin/dashboard');
            } else {
                setError(result.error || 'Authentication failed. Please check your credentials.');
            }
        } catch (err) {
            setError('Login failed. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="admin-login-container">
            <div className="admin-login-card">
                <div className="admin-login-header">
                    <h1>Zinea Admin Portal</h1>
                    <p>Sign in to access the admin dashboard</p>
                </div>

                <form onSubmit={handleSubmit} className="admin-login-form">
                    <div className="form-group">
                        <label htmlFor="email">Email</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={credentials.email}
                            onChange={handleInputChange}
                            required
                            placeholder="Enter admin email"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="password">Password</label>
                        <input
                            type="password"
                            id="password"
                            name="password"
                            value={credentials.password}
                            onChange={handleInputChange}
                            required
                            placeholder="Enter admin password"
                        />
                    </div>

                    {error && <div className="error-message">{error}</div>}

                    <button
                        type="submit"
                        className="login-button"
                        disabled={loading}
                    >
                        {loading ? 'Signing in...' : 'Sign In'}
                    </button>
                </form>

                <div className="admin-login-footer">
                    <p>© 2024 Zinea Admin Portal. All rights reserved.</p>
                </div>
            </div>
        </div>
    );
};

export default AdminLogin;
